import { SandboxInfo } from "components/Sandbox/SandboxInfo";
import type { SandboxEditor } from "features/types/editor";
import { Popover, Box } from "prism-react";
import * as React from "react";

export const SandboxPopover: React.FC<{
  children: JSX.Element;
  sandbox: SandboxEditor;
  showPopover: boolean;
  setShowPopover: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ children, sandbox, showPopover, setShowPopover }) => {
  return (
    <Popover
      contentProps={{
        style: {
          padding: 0,
        },
      }}
      rootProps={{
        open: showPopover,
        onOpenChange: (open) => {
          if (!open) {
            setShowPopover(open);
          }
        },
      }}
      trigger={<Box>{children}</Box>}
    >
      <Box
        css={{
          maxWidth: "320px",
          padding: "$4",
        }}
      >
        <SandboxInfo
          onEditClick={() => {
            setShowPopover(false);
          }}
          sandbox={sandbox}
        />
      </Box>
    </Popover>
  );
};
